import { getDatatableSortParams } from '@/utils/datatableSort';

export default class SuperAdmin {
  constructor(box21_api) {
    this.api = box21_api;
  }

  _listForm(options, filter, releaseVersion) {
    const page = options?.page > 0 ? options.page : 1;
    const itemsPerPage = options?.itemsPerPage > 0 ? options.itemsPerPage : 25;
    const { sortBy, sortDesc } = getDatatableSortParams(options, 'created_at', true);
    const formData = new FormData();
    formData.append('page', String(page));
    formData.append('itemsPerPage', String(itemsPerPage));
    formData.append('sortBy', sortBy);
    formData.append('sortDesc', sortDesc);
    formData.append('filter', filter ?? '');
    formData.append('release_version', releaseVersion ?? '');
    return formData;
  }

  async slowQueries(options, filter, releaseVersion = '') {
    return this.api.post_with_token(
      '/superadmin/slow-queries',
      this._listForm(options, filter, releaseVersion),
    );
  }

  async slowRoutes(options, filter, releaseVersion = '') {
    return this.api.post_with_token(
      '/superadmin/slow-routes',
      this._listForm(options, filter, releaseVersion),
    );
  }

  async exportSlowQueries(options, filter, releaseVersion = '') {
    const { sortBy, sortDesc } = getDatatableSortParams(options, 'created_at', true);
    const formData = new FormData();
    formData.append('sortBy', sortBy);
    formData.append('sortDesc', sortDesc);
    formData.append('filter', filter ?? '');
    formData.append('release_version', releaseVersion ?? '');
    return this.api.post_with_token('/superadmin/slow-queries/export', formData);
  }

  async exportSlowRoutes(options, filter, releaseVersion = '') {
    const { sortBy, sortDesc } = getDatatableSortParams(options, 'created_at', true);
    const formData = new FormData();
    formData.append('sortBy', sortBy);
    formData.append('sortDesc', sortDesc);
    formData.append('filter', filter ?? '');
    formData.append('release_version', releaseVersion ?? '');
    return this.api.post_with_token('/superadmin/slow-routes/export', formData);
  }

  async deleteSlowQueries(scope, releaseVersion = '') {
    const formData = new FormData();
    formData.append('scope', scope);
    formData.append('release_version', releaseVersion ?? '');
    return this.api.post_with_token('/superadmin/slow-queries/delete', formData);
  }

  async deleteSlowRoutes(scope, releaseVersion = '') {
    const formData = new FormData();
    formData.append('scope', scope);
    formData.append('release_version', releaseVersion ?? '');
    return this.api.post_with_token('/superadmin/slow-routes/delete', formData);
  }
}
